<template>
  <div class="field-mapping">
    <b-container fluid class="headLine" id="common-mapping-head">
      <div class="container-left">
        <h6 class="title">{{ setting.isName }} に紐づけ</h6>
        <!-- Start header mapping RESULT CSV -->
        <span class="sub-title">
          {{`定義した${setting.wmsName}を紐づけ または 初期値を設定してください。`}}
        </span>
        <!-- End header mapping RESULT CSV -->
      </div>

      <div class="container-right">
        <!-- Start mode display mapping SYSTEM -->
        <div class="mode-display">
          <form-select-component
            class="select-mode"
            v-model="modeDisplay"
            :options="modeDisplayList"
          >
          <template v-slot:singleLabel="{ itemLabel }">
              <span class="select-mode__value">{{ itemLabel.option.label }}</span>
            </template>
            <template v-slot:options="{ itemOption }">
              <span class="select-mode__value">{{ itemOption.option.label }}</span>
            </template>
        </form-select-component>
          <b-input-group class="mapping-search">
            <b-form-input
              type="search"
              class="custom_search"
              placeholder="検索"
              v-model="mappingSearch"
              v-on:keyup.enter="handleSearch"
            />
            <span class="search-icon material-icons" @click="handleSearch"
              >search</span
            >
          </b-input-group>
        </div>
        <!-- End mode display mapping SYSTEM -->
      </div>
    </b-container>
    <div id="scrollspy-mapping">
      <b-container fluid class="pr-0">
        <!-- Start table mapping SYSTEM -->
        <div
          v-for="(mstItem, index) in mstItemList"
          :key="`mst_${index}`"
          :id="`mst-item-mapping-${index}`"
        >
          <div
            :class="[
              'item-mapping',
              !mstItem.errorFlag
                ? mstItem.isItemEnabledFlag
                  ? 'item-mapping__success'
                  : ''
                : 'item-mapping__error'
            ]"
          >
            <b-list-group-item class="mst-item">
              <b-container
                fluid
                class="item-column"
                @mouseover="handleShowIconDragById(index)"
                @mouseout="chooseIndex = null"
              >
                <span
                  :class="[
                    mstItem.isItemRequiredFlag ? 'visible' : 'invisible',
                    'required'
                  ]"
                >
                  必須
                </span>
                <div class="mst-left-column">
                  <span
                    class="label"
                    @click="onShowMappingModal(mstItem, index)"
                  >
                    {{ mstItem.isItemName }}
                  </span>
                  <div class="edit-mapping-item">
                    <div class="mappingItem-label">
                      <span class="mr-1">=</span>
                      <div
                        class="item-mapped-label d-flex"
                        @click="onShowMappingModal(mstItem, index)"
                      >
                        <div class="d-flex">
                          <span
                            :class="[
                              'label-ellipsis',
                              mstItem.wmsItemLabel
                                ? 'label-ellipsis__wms-item'
                                : 'display-none'
                            ]"
                          >
                            {{ mstItem.wmsItemLabel }}
                          </span>
                          <span v-if="(mstItem.wmsItemLabel && mstItem.userDefineLabel) ||
                           (mstItem.wmsItemLabel && (mstItem.systemDefaultLabel || (mstItem.systemDefaultExplanation && mstItem.systemDefaultExplanationFlag)))">、</span>
                        </div>
                        <div class="d-flex">
                          <span
                            :class="[
                              'label-ellipsis',
                              mstItem.userDefineLabel
                                ? 'label-ellipsis__user-define'
                                : 'display-none'
                            ]"
                          >
                            {{ mstItem | displayUserDefineLabel }}
                          </span>
                        </div>
                        <span
                          v-if="!mstItem.userDefineLabel"
                          :class="[
                            'label-ellipsis',
                            mstItem.systemDefaultLabel ||
                            (mstItem.systemDefaultExplanation &&
                              mstItem.systemDefaultExplanationFlag)
                              ? 'label-ellipsis__system-default'
                              : 'display-none',
                          ]"
                        >
                          {{ mstItem | displaySystemDefaultLabel }}
                        </span>
                        <!-- Show System Default -->
                        <span
                          class="system-default-label label-ellipsis"
                          v-if="!mstItem.wmsItemLabel && !mstItem.userDefineLabel"
                        >
                          {{
                            mstItem.systemDefaultLabel
                              ? mstItem.systemDefaultLabel
                              : mstItem.systemDefaultExplanation &&
                                mstItem.systemDefaultExplanationFlag
                              ? mstItem.systemDefaultExplanation
                              : ""
                          }}
                        </span>
                        <span
                          class="material-icons edit_icon"
                          v-show="chooseIndex === index"
                        >
                          edit
                        </span>
                      </div>
                    </div>
                  </div>
                  <small
                    class="text-required p-0"
                    v-if="!mstItem.isItemEnabledFlag && mstItem.errorFlag"
                  >
                    {{ msgRequiredValueMapped }}
                  </small>
                </div>
              </b-container>
            </b-list-group-item>
          </div>
        </div>
        <div v-if="isDisplayedNoDataMessage" class="no-data">
          <span>検索結果がありません。</span>
        </div>
        <!-- End table mapping SYSTEM -->
      </b-container>
    </div>
    <CommonFieldMappingModal
      ref="mapping-item-modal"
      :itemWmsMappingList="wmsItemList"
      :tableManagementList="mstTableManagementList"
      :replacedCharacters="replacedCharacters"
      :placeHolderFieldForList="placeHolderFieldForList"
      @on-mapping="onMappingItem"
    />
  </div>
</template>

<script>
import mixinAutoResize from '../../mixins/autoResize.js'
import CommonFieldMappingModal from './CommonFieldMappingModal.vue'
import FlashMessage from '../../common/flash-message.component'
import StrinngUtil from '../../_helpers/string.util'
import { FieldDataType } from '../../enums/field-data-type.enums.js'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import AppConstants from '../../constants/app.constants'
// Mode show all items
const SHOW_ALL = 2
// Mode show items mapped
const SHOW_ITEMS_IMPORTED = 1
// Mode show items don't mapping
const SHOW_ITEMS_NOT_IMPORTED = 0
// Mode show items required
const SHOW_ITEMS_REQUIRED = 3
export default {
  mixins: [mixinAutoResize],
  props: {
    mappingNo: String,
    setting: Object
  },
  components: {
    CommonFieldMappingModal,
    FormSelectComponent
  },
  data() {
    return {
      wmsItemList: [],
      mstItemList: [],
      chooseIndex: null,
      mappingSearch: null,
      modeDisplay: { mode: SHOW_ALL, label: '全て表示' },
      modeDisplayList: [
        { mode: SHOW_ALL, label: '全て表示' },
        { mode: SHOW_ITEMS_REQUIRED, label: '必須のみ表示' },
        { mode: SHOW_ITEMS_IMPORTED, label: '設定済みのみ表示' },
        { mode: SHOW_ITEMS_NOT_IMPORTED, label: '未設定のみ表示' }
      ],
      msgRequiredValueMapped: '必須項目です、設定してください。',
      originalMstItemList: [],
      wmsItemLabel: '',
      userDefineLabel: '',
      systemDefaultLabel: '',
      mstTableManagementList: [],
      mappingData: {},
      isErrorMapping: false,
      replacedCharacters: '',
      isLoading: false,
      isDisplayedNoDataMessage: false,
      placeHolderFieldForList: ''
    }
  },
  async created() {
    this.mappingSearch = null
    await this.fetchRequest()
    await this.$_generateFeatchData(this.mappingData)
  },
  watch: {
    modeDisplay(newValue) {
      this.displayItemMappedByModeFilter()
    },
    isLoading() {
      this.$emit('isLoading', this.isLoading)
    }
  },
  filters: {
    displayUserDefineLabel(mstItem) {
      return mstItem.wmsItemLabel && mstItem.userDefineLabel
        ? `${mstItem.userDefineLabel}`
        : mstItem.userDefineLabel
    },
    displaySystemDefaultLabel(mstItem) {
      if (mstItem.wmsItemLabel || mstItem.userDefineLabel) {
        if (mstItem.systemDefaultLabel) {
          return `${mstItem.systemDefaultLabel}`
        } else if (mstItem.systemDefaultExplanation && mstItem.systemDefaultExplanationFlag) {
          return `${mstItem.systemDefaultExplanation}`
        }
      }
    }
  },
  computed: {},
  methods: {
    /** データを取得する */
    async fetchRequest() {
      const res = await this.$axios.get(`/mapping/${this.mappingNo}`)
      this.mappingData = res.data
    },
    /**
     * 編集アイコンを表示
     * @param {number} index リスト データのインデックス
     */
    handleShowIconDragById(index) {
      this.chooseIndex = index
    },
    /**
     * ルールの検証を取得
     * @return {object} 値を入力する必要があるフィールドのルール検証
     */
    getMixinRules() {
      return this.editableMixin.mappingItem[`${this.mappingNo}`]
    },
    /**
     * mst アイテムのモーダル マッピングを表示
     * @param {object} mstItem アイテムのマッピングが必要
     * @param {number} id アイテム インデックス
     */
    onShowMappingModal(mstItem, id) {
      const rulesMinMaxValue = this.getMixinRules()
      this.$refs['mapping-item-modal'].showModal(
        mstItem,
        id,
        rulesMinMaxValue
      )
    },
    /**
     * ファイル csv 内の wms アイテムまたはユーザー定義値をシステム アイテムにマップする
     * @param {object} wmsItem csvファイルのwmsアイテムとユーザー定義値
     * @param {number} id インデックスをマップする必要があります
     */
    async onMappingItem(wmsItem, id) {
      if (!wmsItem) {
        return
      }
      const mstItem = this.mstItemList[id]
      // If user has mapped, set isItemEnabledFlag = 1
      if (wmsItem.wmsNo || wmsItem.defaultValue) {
        mstItem.wmsNo = wmsItem.wmsNo
        mstItem.defaultValue = wmsItem.defaultValue
        mstItem.isItemEnabledFlag = 1
      } else {
        // If user don't mapped, set defaultValue = null, wmsNo = null and isItemEnabledFlag = 0
        mstItem.wmsNo = null
        mstItem.defaultValue = null
        mstItem.isItemEnabledFlag = 0
      }
      mstItem['wmsItemLabel'] = wmsItem.wmsNo ? wmsItem.wmsItemName : null
      if (mstItem.tableNo === AppConstants.IS_ITEM_FIELD_TR_TASK && mstItem.isItemNo === AppConstants.IS_ITEM_FIELD_BATCH_NO && mstItem.wmsItemLabel) {
        mstItem.systemDefaultExplanationFlag = false
      } else if (mstItem.isItemRequiredFlag === 0) {
        mstItem.systemDefaultExplanationFlag = true
      }
      mstItem.errorFlag = false
      await this.buildItemMappedLabel()
      // TODO
      this.mstItemList = [...this.mstItemList]
      this.displayItemMappedByModeFilter()
    },
    /** マッピングデータ保存処理 */
    async saveMapping() {
      this.isLoading = true
      let request = null
      try {
        let mstItemData = []
        this.checkWmsListItems = Boolean(this.wmsItemList.length)
        if (this.checkRequiredFieldsMapped()) {
          this.isLoading = false
          this.$emit('check-mst-item-mapped', {
            checkWmsListItems: this.checkWmsListItems,
            isErrorMapping: this.isErrorMapping
          })
          return
        }
        this.mstItemList.map(mstItem => {
          mstItemData.push({
            isItemEnabledFlag: mstItem.isItemEnabledFlag,
            isItemName: mstItem.isItemName,
            isItemNo: mstItem.isItemNo,
            mappingNo: mstItem.mappingNo,
            wmsNo: mstItem.wmsNo,
            defaultValue: mstItem.defaultValue,
            serialNo: 1
          })
        })
        request = await this.$axios.post(`/mapping/${this.mappingNo}`, {
          mstMappingIsItem: mstItemData
        })
        this.checkMstItemMapped()
        this.isLoading = false
        FlashMessage.getInstance().showSuccessMessage('保存完了。')
      } catch (err) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(err)
      }
      return request
    },
    /** マッピングされた必須フィールドを確認してください
     * @return {boolean} true: 必須フィールドがマッピングされていません; false: マップされた必須フィールド
     */
    checkRequiredFieldsMapped() {
      // 必須フィールドがマッピングされていない場合にエラー フラグを更新する
      this.mstItemList = [
        ...this.mstItemList.map(mstItem => ({
          ...mstItem,
          errorFlag:
            !mstItem.isItemEnabledFlag && mstItem.isItemRequiredFlag === 1 && !mstItem.systemDefaultValue
        }))
      ]
      const errorFlag = this.mstItemList.some(mstItem => mstItem.errorFlag)
      this.isErrorMapping = errorFlag
      return errorFlag
    },
    /**
     * データを取得する
     * @param {object} mappingData マッピングデータ
     */
    $_generateFeatchData(mappingData) {
      this.wmsItemList = []
      this.mstItemList = []
      this.originalMstItemList = []
      this.mstTableManagementList = []
      if (!mappingData) {
        return
      }
      if (mappingData.mstMappingWmsItem.length) {
        // If user add csv columns then add into wms item list for mapping
        // and green tick
        this.wmsItemList = JSON.parse(
          JSON.stringify(mappingData.mstMappingWmsItem)
        )
      }
      // Build mst item mapping list
      mappingData.mstIsItem.forEach((item, index) => {
        const resultsManageData = mappingData.mstTableManagement.filter(
          mstManag => mstManag.isItemNo === item.isItemNo
        )
        // Add item name for label of item mapping column
        if (resultsManageData.length) {
          item['isItemName'] = resultsManageData[0].itemName || ''
          const checkDataType =
            resultsManageData[0].dataType ||
            resultsManageData[0].dataType === 0
          item['dataType'] = checkDataType
            ? resultsManageData[0].dataType
            : ''
        }
        const resultsMstItem = mappingData.mstMappingIsItem.filter(
          mstItem => mstItem.isItemNo === item.isItemNo
        )
        if (resultsMstItem.length) {
          const isItemMapped =
            resultsMstItem[0].wmsNo || resultsMstItem[0].defaultValue
          // Build data for mst item list if user has mapped or mst item list has system default value
          item['isItemEnabledFlag'] = isItemMapped
            ? resultsMstItem[0].isItemEnabledFlag
            : 0
          item['defaultValue'] = resultsMstItem[0].defaultValue
          item['lineNum'] = resultsMstItem[0].lineNum
          item['wmsNo'] = resultsMstItem[0].wmsNo
        } else {
          // Build data default for mst item list if user don't mapping
          item['isItemEnabledFlag'] = 0
          item['defaultValue'] = null
          item['wmsNo'] = null
        }
        item['errorFlag'] = false
        if (item['isItemNo'] === 'batchNo' && item['isItemRequiredFlag'] === 1) {
          item['systemDefaultExplanationFlag'] = false
        } else {
          item['systemDefaultExplanationFlag'] = true
        }
        this.mstItemList.push(item)
      })
      this.mstTableManagementList = [...mappingData.mstTableManagement]
      this.replacedCharacters = mappingData.replacedCharacters
      const genCodeList = [...mappingData.mstGenCode]
      this.buildItemMappedLabel()
      this.buildDataTypeLabel(genCodeList)
      this.checkMstItemMapped()
      this.displayItemMappedByModeFilter()
      this.isDisplayedNoDataMessage = false
    },
    /** データ型ごとにラベルを作成する */
    buildDataTypeLabel(mstGenCode) {
      this.mstItemList.forEach(mstItem => {
        const genCode = mstGenCode.find(
          genCode => genCode.code === mstItem.dataType
        )
        mstItem['dataTypeName'] = genCode.name || ''
      })
    },
    /** マップされたアイテムのラベルを作成 */
    buildItemMappedLabel() {
      this.mstItemList.forEach(mstItem => {
        const wmsItem = this.wmsItemList.find(
          item => item.wmsNo === mstItem.wmsNo
        )
        mstItem['wmsItemLabel'] =
          wmsItem && wmsItem.wmsNo ? wmsItem.wmsItemName : null
        if (mstItem.tableNo === AppConstants.IS_ITEM_FIELD_TR_TASK && mstItem.isItemNo === AppConstants.IS_ITEM_FIELD_BATCH_NO && mstItem.wmsItemLabel) {
          mstItem.systemDefaultExplanationFlag = false
        }
        this.buildDefineValueLabel(mstItem, 'defaultValue', 'userDefineLabel')
        this.buildDefineValueLabel(
          mstItem,
          'systemDefaultValue',
          'systemDefaultLabel'
        )
      })
    },
    /**
     * データ型がリストの場合、obecjt のラベルを作成します
     * @param {object} mstItem ラベルを作成する必要があるオブジェクト
     * @param {string} propertyName オブジェクトのプロパティ
     * @param {string} propertyLabel プロパティ新しい必要性建設
     */
    buildDefineValueLabel(mstItem, propertyName, propertyLabel) {
      // Convert value from number to string for item label of user has mapped
      const defaultValue = StrinngUtil.toString(mstItem[propertyName])
      if (
        defaultValue &&
        mstItem.dataType === FieldDataType.LIST
      ) {
        const genCode = this.buildItemMappedLabelByGenCode(
          mstItem,
          defaultValue
        )
        mstItem[propertyLabel] = genCode ? genCode.name : (mstItem.defaultValue ? mstItem.defaultValue : mstItem.systemDefaultValue)
        this.placeHolderFieldForList = mstItem[propertyLabel]
      } else {
        mstItem[propertyLabel] = defaultValue || null
      }
    },
    /**
     * gen コードでマップされたアイテムのビルド ラベル
     * @param {object} mstItem 建造が必要なアイテム
     * @param {string} valueItemMapped マップされたアイテムの値
     */
    buildItemMappedLabelByGenCode(mstItem, valueItemMapped) {
      let genCode
      this.mstTableManagementList.map(item => {
        if (item.isItemNo === mstItem.isItemNo) {
          genCode = item.mstGenCode.find(
            genCode => genCode.code.toString() === valueItemMapped
          )
        }
      })
      return genCode
    },
    /** アイコン チェック ティック フラグを発行します。 */
    checkMstItemMapped() {
      const checkWmsListItems = Boolean(this.wmsItemList.length)
      this.$emit('check-mst-item-mapped', {
        checkWmsListItems
      })
    },
    /** ユーザーフィルターの表示項目 */
    displayItemMappedByModeFilter() {
      const modeDisplay = this.modeDisplay.mode
      let dataNotFound = true
      this.mstItemList.map((item, index) => {
        const element = document.getElementById(`mst-item-mapping-${index}`)
        if (element) {
          const required = !!item.isItemRequiredFlag
          // If mode is not display item required
          const modeNotRequired =
            item.isItemEnabledFlag === modeDisplay || modeDisplay === SHOW_ALL
          // Check mode is show item required or not required
          const condition =
            modeDisplay === SHOW_ITEMS_REQUIRED ? required : modeNotRequired
          // Show item by condition of user
          element.style.display = condition ? '' : 'none'
          if (condition) {
            dataNotFound = false
          }
        }
      })
      this.isDisplayedNoDataMessage = dataNotFound
      if (this.mappingSearch) {
        this.handleSearch()
      }
    },
    /**
     * 検索されたユーザー値によるアイテムの表示
     */
    async handleSearch() {
      const modeDisplay = this.modeDisplay.mode
      let dataNotFound = true
      let valueMappingLowerCase = this.mappingSearch
        ? this.mappingSearch.toLowerCase().trim()
        : ''
      this.mstItemList.map((item, index) => {
        const elementItemMapping = document.getElementById(
          `mst-item-mapping-${index}`
        )
        const isItemName = StrinngUtil.toLowerCase(item.isItemName)
        const userDefineValueLabel = StrinngUtil.toLowerCase(
          item.userDefineLabel
        )
        const wmsItemLabel = StrinngUtil.toLowerCase(item.wmsItemLabel)
        const systemDefaultLabel = StrinngUtil.toLowerCase(
          item.systemDefaultLabel
        )
        // チェック値のユーザー検索には、アイテム ラベル、ユーザー定義のラベル、および wms アイテム ラベルが含まれます。
        const checkValueSearch =
          isItemName.includes(valueMappingLowerCase) ||
          userDefineValueLabel.includes(valueMappingLowerCase) ||
          wmsItemLabel.includes(valueMappingLowerCase) ||
          systemDefaultLabel.includes(valueMappingLowerCase)
        // 条件フィルター表示項目 必須
        const conditionItemRequired = item.isItemRequiredFlag && modeDisplay === SHOW_ITEMS_REQUIRED
        // 表示モードによる条件フィルター
        const conditionFilter =
          (item.isItemEnabledFlag === modeDisplay ||
            modeDisplay === SHOW_ALL || conditionItemRequired)
        let conditionSearch = true
        if (!elementItemMapping) {
          return
        }
        // ユーザーの検索値が空でない場合は、表示モード基準とユーザーの検索値で検索します
        if (valueMappingLowerCase) {
          conditionSearch = conditionFilter && checkValueSearch
        } else {
          conditionSearch = conditionFilter
        }
        elementItemMapping.style.display = conditionSearch ? '' : 'none'
        if (conditionSearch) {
          dataNotFound = false
        }
      })
      this.isDisplayedNoDataMessage = dataNotFound
    }
  }
}
</script>

<style lang="scss" scoped>
.field-mapping {
  // 64px (Area tab and action button mapping)
  height: calc(100% - 64px);
  .item-mapping {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    background: #ffffff;
    margin: 2px 0 1px 0;
    height: auto;
    &__error {
      border-left: 4px solid #b41b3e;
      .required {
        margin-left: 9px;
      }
    }
    &__success {
      border-left: 4px solid #1fa790;
      .required {
        margin-left: 9px;
      }
    }
    .mst-item {
      border: none;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 100%;
      &:hover {
        background: $text_hover_bg_color;
      }
      .item-column {
        width: 100%;
        padding: 7px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .mst-left-column {
          display: flex;
          flex-direction: column;
          padding: 0px 10px 0px 0px;
          width: 100%;
          .label {
            cursor: pointer;
            width: fit-content;
            @include textOverflowEllipsis(true);
            &:hover {
              background: #E3E8F2;
            }
          }
          .edit-mapping-item {
            display: flex;
            align-items: center;
            width: 100%;
            .mappingItem-label {
              display: flex;
              align-items: center;
              .item-mapped-label {
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                &:hover {
                  background: #E3E8F2;
                }
                .label-ellipsis {
                  max-width: 75vw;
                  word-break: break-all;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  &__wms-item {
                    color: #1fa690;
                  }
                  &__user-define {
                    color: #252422;
                  }
                  &__system-default {
                    color: #7c7c7a;
                  }
                }
                .system-default-label {
                  color: #7c7c7a;
                }
              }
            }
          }
        }
      }
    }
    .list-group {
      list-style-type: none;
      min-height: 46px;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
  .headLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px 0px 10px 0px;
    padding-right: 0px !important;
    padding-left: 0px !important;
    max-height: 100px;
    .container-left {
      padding-left: 15px;
      min-width: 100px;
      .title {
        font-weight: 900;
        word-break: break-all;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .sub-title {
        font-weight: 400;
        @include responsive-fs(12);
        color: #666563;
        @include textOverflowEllipsis(true);
      }
    }
    .container-right {
      display: flex;
      flex: 0 1 495px;
      align-items: center;
      .mode-display {
        display: inherit;
        align-items: center;
        width: 100%;
        .select-mode {
          width: 250px;
          margin-right: 16px;
          &__value {
            font-weight: 400 !important;
            color: #252422 !important;
          }
        }
        .mapping-search {
          display: flex;
          height: 50px;
          flex: 1 1 226px;
          text-indent: 0px !important;
          min-width: 100px;
          align-items: center;
          input {
            height: 40px;
          }
          .custom_search {
            position: relative;
            border-radius: 4px;
            padding-right: 35px;
          }
        }
      }
    }
  }
  .required {
    background: rgba(37, 36, 34, 0.8);
    border-radius: 2px;
    color: #fff;
    min-width: 40px;
    min-height: 27px;
    text-align: center;
    @include responsive-fs(12);
    padding: 4px 8px;
    margin-left: 12px;
    margin-right: 24px;
    border: none;
  }

  // MATERIAL ICONS CUSTOM
  .material-icons {
    &.edit_icon {
      color: $sucess;
    }
    &.search-icon {
      position: absolute;
      cursor: pointer;
      right: 10px;
      z-index: 10;
    }
  }
  .text-required {
    font-weight: 700;
    @include responsive-fs(12);
    color: #b41b3e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonIsFieldMapping.vue